// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

ion-card ion-card-header div.ion-card-header-extra {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
ion-card ion-card-header div.ion-card-header-extra-badge {
  justify-self: right;
}
ion-card ion-card-header ion-badge {
  margin-left: 4px;
  margin-top: 4px;
}
ion-card ion-card-title {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
ion-card ion-card-subtitle {
  color: black;
}
ion-card ion-card-content {
  color: black;
}

.opactiy-6 {
  opacity: 0.6;
}

.none {
  --background: #8F9094;
}

.initial {
  --background: #1dad94;
}

.quoted {
  --background: #1c33a3;
}

.approved {
  --background: #45b020;
}

.completed {
  --background: #b0af20;
}

.deleted {
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/recommendation-card/recommendation-card.component.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/components/recommendation-card/recommendation-card.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;ACCJ;;ADIQ;EACI,aAAA;EACA,8BAAA;ACDZ;ADIQ;EACI,mBAAA;ACFZ;ADKQ;EACI,gBAAA;EACA,eAAA;ACHZ;ADOI;EACI,mBAAA;EACA,2BAAA;EACA,uBAAA;ACLR;ADQI;EACI,YAAA;ACNR;ADSI;EACI,YAAA;ACPR;;ADWA;EACI,YAAA;ACRJ;;ADWA;EACI,qBAAA;ACRJ;;ADWA;EACI,qBAAA;ACRJ;;ADWA;EACI,qBAAA;ACRJ;;ADWA;EACI,qBAAA;ACRJ;;ADWA;EACI,qBAAA;ACRJ;;ADWA;EACI,8BAAA;ACRJ","sourcesContent":[":host {\r\n    width: 100%;\r\n}\r\n\r\nion-card {\r\n    ion-card-header {\r\n        div.ion-card-header-extra {\r\n            display: grid;\r\n            grid-template-columns: 1fr 1fr;\r\n        }\r\n\r\n        div.ion-card-header-extra-badge {\r\n            justify-self: right;\r\n        }\r\n\r\n        ion-badge {\r\n            margin-left: 4px;\r\n            margin-top: 4px;\r\n        }\r\n    }\r\n\r\n    ion-card-title {\r\n        white-space: nowrap;\r\n        overflow: hidden !important;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    ion-card-subtitle {\r\n        color: black;\r\n    }\r\n\r\n    ion-card-content {\r\n        color: black;\r\n    }\r\n}\r\n\r\n.opactiy-6 {\r\n    opacity: 0.6;\r\n}\r\n\r\n.none {\r\n    --background: #8F9094;\r\n}\r\n\r\n.initial {\r\n    --background: #1dad94;\r\n}\r\n\r\n.quoted {\r\n    --background: #1c33a3;\r\n}\r\n\r\n.approved {\r\n    --background: #45b020;\r\n}\r\n\r\n.completed {\r\n    --background: #b0af20;\r\n}\r\n\r\n.deleted {\r\n    color: var(--ion-color-danger);\r\n}",":host {\n  width: 100%;\n}\n\nion-card ion-card-header div.ion-card-header-extra {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\nion-card ion-card-header div.ion-card-header-extra-badge {\n  justify-self: right;\n}\nion-card ion-card-header ion-badge {\n  margin-left: 4px;\n  margin-top: 4px;\n}\nion-card ion-card-title {\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\nion-card ion-card-subtitle {\n  color: black;\n}\nion-card ion-card-content {\n  color: black;\n}\n\n.opactiy-6 {\n  opacity: 0.6;\n}\n\n.none {\n  --background: #8F9094;\n}\n\n.initial {\n  --background: #1dad94;\n}\n\n.quoted {\n  --background: #1c33a3;\n}\n\n.approved {\n  --background: #45b020;\n}\n\n.completed {\n  --background: #b0af20;\n}\n\n.deleted {\n  color: var(--ion-color-danger);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
